import { requestPDServer } from '@/utils/fetchResponse';
import Cookies from 'js-cookie';
const myBaseUrl = process.env.VUE_APP_BASE_API;
// const userInfo = store.getters['socket/getUserInfo'](platformUserId);

// 媒体库照片移动，由所有分类移入到指定分类
// https://talkytimes.com/platform/gallery/photo/album/add-photos
//{"idsAlbums":[71052],"idsPhotos":[50758284]}
// idsAlbums 分类id
// idsPhotos 照片id
// 返回：
export const addPhotosToAlbum = (data) => {
  return requestPDServer('/platform/gallery/photo/album/add-photos', data);
};

// 媒体库获取照片分类
// https://talkytimes.com/platform/gallery/photo/album/list
// limit: 100
// 返回：
// {
//     "items": [
//         {
//             "idAlbum": 71052,
//             "name": "1111",
//             "idUser": 69593048,
//             "previewUrl": "https://i.gstatvb.com/shpzkl30u73a67mik.r170x170.2a446203.jpg",
//             "dateCreated": "2025-08-11T06:01:16+00:00"
//         }
//     ],
//     "cursor": "71052"
// }
export const getPhotoAlbumList = (data) => {
  return requestPDServer('/platform/gallery/photo/album/list', data);
};
// 媒体库添加照片分类
// https://talkytimes.com/platform/gallery/photo/album/create
// 参数：{"name":"222"}
// 返回：{"idAlbum":72048}
export const createPhotoAlbum = (data) => {
  return requestPDServer('/platform/gallery/photo/album/create', data);
};
// 媒体库删除照片分类
// https://talkytimes.com/platform/gallery/photo/album/delete
// {"idAlbum":72046}
export const deletePhotoAlbum = (data) => {
  return requestPDServer('/platform/gallery/photo/album/delete', data);
};
// 获取邮箱发视频的权限
// https://talkytimes.com/platform/correspondence/video/forbidden-tags
// {"idInterlocutor":104474193}
export const getEmailVideoForbiddenTags = (data) => {
  return requestPDServer('/platform/correspondence/video/forbidden-tags', data);
};
// 获取邮箱发图片的权限
// https://talkytimes.com/platform/correspondence/photo/forbidden-tags
// {"idInterlocutor":104474193}
export const getEmailPhotoForbiddenTags = (data) => {
  return requestPDServer('/platform/correspondence/photo/forbidden-tags', data);
};
// 删除媒体库照片
// https://talkytimes.com/platform/gallery/photo/delete
// {"idPhoto":51141959}
export const deletePhoto = (data) => {
  return requestPDServer('/platform/gallery/photo/delete', data);
};
// 删除媒体库视频
// https://talkytimes.com/platform/gallery/video/delete
// {"idsVideos":[7374269]}
export const deleteVideo = (data) => {
  return requestPDServer('/platform/gallery/video/delete', data);
};
function setCookie() {
  const activeUser = localStorage.getItem('activeUser');
  if (activeUser) {
    const user = JSON.parse(activeUser);
    Cookies.set('tld-token', user.pdToken);
  }
}
